document.addEventListener('DOMContentLoaded', function () {
  const menuItems = document.querySelectorAll('[data-menu-item]');

  menuItems.forEach((menuItem) => {
    const submenu = menuItem.querySelector('[data-submenu]');
    if (!submenu) return; // Skip if no submenu found

    let hoverTimeout;

    // Show submenu on hover
    menuItem.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout);
      menuItem.setAttribute('data-open', 'true');
    //   submenu.style.opacity = '1';
      submenu.style.transform = 'translateY(0)';
      submenu.style.visibility = 'visible';
    });

    // Hide submenu when leaving menu area
    menuItem.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(() => {
        menuItem.removeAttribute('data-open');
        // submenu.style.opacity = '0';
        submenu.style.transform = 'translateY(-1.5rem)';
        submenu.style.visibility = 'hidden';
      }, 100);
    });
  });
});